var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jumbotron text-center"},[_c('h2',{staticClass:"font-weight-bold"},[_vm._v("This Page is Currently in Maintenance Mode...")])])
}]

export { render, staticRenderFns }